<template>
    <v-list density="compact">
        <div v-for="group in groups" :key="group.id">
            <component v-if="group.header != undefined" :is="group.header" :group="group" />
            <div v-if="group.title != undefined" class="d-flex" style="padding-right:16px;">
                <v-list-subheader v-if="group.items.length > 0 || group.actions != undefined">
                    <div style="white-space: normal;"> {{ group.title }} </div>
                </v-list-subheader>
                <v-spacer></v-spacer>
                <div v-if="group.actions != undefined">
                    <tool-button v-for="(action, index) in group.actions" :key="index" :title="action.title"
                        :icon="action.icon" :onclick="action.onclick" :context="group" />
                </div>
            </div>
            <v-list-item v-for="item in group.items" :key="item.id" :value="item.id" color="primary"
                :active="active(item)" class="custom-spacer" @click="navigate(item)">
                <template v-slot:prepend>
                    <v-badge v-if="item.badge && item.badge.content > 0 && item.actions" :content="item.badge.content"
                        :color="item.badge.color">
                        <component v-if="item.component" :is="item.component" v-bind="item.payload" />
                        <tool-icon v-else-if="item.icon" :name="item.icon" />
                        <v-avatar v-else :image="item.image" :size="32"></v-avatar>
                    </v-badge>
                    <component v-else-if="item.component" :is="item.component" v-bind="item.payload" />
                    <tool-icon v-else-if="item.icon" :name="item.icon" />
                    <v-avatar v-else-if="item.image" :image="item.image" :size="32"></v-avatar>
                </template>
                <template v-slot:append>
                    <v-badge v-if="item.sub_badge && item.sub_badge.content>0"
                        :content="item.sub_badge.content" inline :color="item.sub_badge.color"></v-badge>
                    <tool-button-context v-if="item.actions" :actions="item.actions" />
                    <v-badge v-else-if="item.badge && item.badge.content > 0" :color="item.badge.color"
                    :content="item.badge.content" inline></v-badge>

                </template>
                <v-list-item-title>
                    {{ item.title }}
                </v-list-item-title>
            </v-list-item>
            <component v-if="group.footer != undefined" :is="group.footer" :group="group" />
        </div>
    </v-list>
</template>

<script>
import RouterLink from './RouterLink.vue';
import ToolButton from './ToolButton.vue';
import ToolButtonContext from './ToolButtonContext.vue';
import ToolIcon from './ToolIcon.vue';

export default {
    components: {
        ToolButton, ToolIcon, ToolButtonContext, RouterLink,
    },
    name: 'SideBar',
    props: {
        data: Array,
    },
    computed: {
        groups() {
            return this.data;
        },
    },
    methods: {
        navigate(item) {
            this.$emit('navigate', item.route);
        },
        active(item) {
            const active = item.active;
            if (active == null) {
                return this.$router.match(item.route);
            }
            return active;
        },
    },
};
</script>

<style scoped>
.custom-spacer :deep(.v-list-item__prepend > .v-list-item__spacer) {
    width: 16px;
}

.custom-spacer :deep(.v-list-item__prepend > .avatar ~ .v-list-item__spacer) {
    width: 0px;
}
</style>
